export interface PromptEntry {
  readonly key: string;
  readonly label: string;
}

export class PromptLayer {
  readonly element: HTMLElement;
  private readonly entriesEl: HTMLElement;
  private lastSignature = '';

  constructor() {
    this.element = document.createElement('div');
    this.element.className = 'prompt-layer';

    this.entriesEl = document.createElement('div');
    this.entriesEl.className = 'prompt-entries';
    this.element.append(this.entriesEl);

    this.hide();
  }

  show(input: string | PromptEntry | readonly PromptEntry[], label?: string): void {
    const entries: PromptEntry[] = this.normalize(input, label);
    const signature = entries.map((e) => `${e.key}::${e.label}`).join('|');
    if (signature === this.lastSignature) return;
    this.lastSignature = signature;

    this.entriesEl.innerHTML = '';
    for (const entry of entries) {
      const wrapper = document.createElement('div');
      wrapper.className = 'prompt-entry';
      const key = document.createElement('kbd');
      key.className = 'prompt-key';
      key.textContent = entry.key;
      const text = document.createElement('span');
      text.className = 'prompt-label';
      text.textContent = entry.label;
      wrapper.append(key, text);
      this.entriesEl.append(wrapper);
    }

    this.element.classList.add('is-visible');
  }

  hide(): void {
    if (this.lastSignature === '') return;
    this.lastSignature = '';
    this.element.classList.remove('is-visible');
  }

  isVisible(): boolean {
    return this.lastSignature !== '';
  }

  private normalize(
    input: string | PromptEntry | readonly PromptEntry[],
    label?: string
  ): PromptEntry[] {
    if (typeof input === 'string') {
      return [{ key: input, label: label ?? '' }];
    }
    if (Array.isArray(input)) {
      return [...input];
    }
    return [input as PromptEntry];
  }
}
